/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as eventServices from "../services/eventService"
// import GameBoxHorse from './sub_components/gameboxhorse'
import { staticContentsImagePath as BASE_IMAGE_PATH } from '../configs/const';
import Header from './header'
import Menu from './menu'
let socket = null
class GameList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            game: [],
            gameCode: "",
            pinnedEvents: [],
            loading: true,
            mktFeedBooks: {},
            subscribedMarkets: []
        };
    }
    parseBook(data) {
        !!data && data.length > 0 && data.forEach((mkt, i) => {
            // let book = !!mkt.metadata && !!mkt.metadata.book ? stringParser.deSrlz("book|" + mkt.metadata.book) : {}
            let book = !!mkt.metadata && !!mkt.metadata.book ? JSON.parse(mkt.metadata.book) : null
            data[i].metadata = {}
            data[i].metadata.book = book
        })
        return data
    }
    async componentWillReceiveProps() {
        setTimeout(async () => {
            let homeData = localStorage.getItem("homeData")
            homeData = JSON.parse(homeData)
            if (!homeData) {
                return false
            }
            if (!homeData) {
                homeData = await eventServices.getHomeData()
                homeData = this.parseBook(homeData)
                localStorage.setItem('homeData', JSON.stringify(homeData))
            }
            let userEventCktData = homeData.length > 0 && homeData.filter((mkt) => {
                return mkt.eventType.id === "4"
            })
            let userEventSocData = homeData.length > 0 && homeData.filter((mkt) => {
                return mkt.eventType.id === "1"
            })
            let userEventTenData = homeData.length > 0 && homeData.filter((mkt) => {
                return mkt.eventType.id === "2"
            })
            let userEventKbdData = homeData.length > 0 && homeData.filter((mkt) => {
                return mkt.eventType.id === "400"
            })
            let userEventElcData = homeData.length > 0 && homeData.filter((mkt) => {
                return mkt.eventType.id === "500"
            })
            let userEventHorseData = homeData.length > 0 && homeData.filter((mkt) => {
                return mkt.eventType.id === "7"
            })
            let userEventHoundData = homeData.length > 0 && homeData.filter((mkt) => {
                return mkt.eventType.id === "4339"
            })
            this.getEvtData(userEventCktData, userEventSocData, userEventTenData, userEventKbdData, userEventElcData, userEventHorseData, userEventHoundData)
        }, 100)
    }
    updateBook(marketId, book) {
        let feedBooks = this.state.mktFeedBooks
        feedBooks[marketId] = book
        this.setState({ mktFeedBooks: feedBooks })
    }
    arrayGroupBy(ary, attr) {
        let group = ary.reduce((r, a) => {
            r[a[attr]] = [...r[a[attr]] || [], a];
            return r;
        }, {});
        return group
    }
    async getEvtData(userEventCktData, userEventSocData, userEventTenData, userEventKbdData, userEventElectData, userEventHorseData, userEventHoundData) {
        let userEventData = window.location.pathname === "/game/7" ? userEventHorseData : userEventHoundData
        let events = []
        let countryGroup = !!userEventData ? userEventData.reduce((r, a) => {
            r[a.event.countryCode] = [...r[a.event.countryCode] || [], a];
            return r;
        }, {}) : {}
        let finalData = {}
        Object.keys(countryGroup).forEach((cn, i) => {
            let evtGroup = countryGroup[cn].reduce((r, a) => {
                r[a.event.id] = [...r[a.event.id] || [], a];
                return r;
            }, {});
            finalData[cn] = evtGroup
        })
        // console.log(finalData)



        !!userEventData && userEventData.length > 0 && userEventData.forEach((mkt, i) => {
            if (!mkt) {
                return false
            }
            let eventIndex = events.findIndex(x => x.id === mkt.event.id)
            let market = { ...mkt.catalogue, ...mkt.marketCondition }
            market.metadata = mkt.metadata
            market.marketBook = !!market.metadata && !!market.metadata.book ? market.metadata.book : {}
            market.marketId = mkt.catalogue.marketId
            if (Object.keys(market.marketBook).length === 0) {
                let baseData = {
                    marketId: market.marketId,
                    status: "OPEN",
                    runners: []
                }
                market.runners.forEach((rnr) => {
                    let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": "", "size": "", "line": "" }, { "price": "", "size": "", "line": "" }, { "price": "", "size": "", "line": "" }], "lay": [{ "price": "", "size": "", "line": "" }, { "price": "", "size": "", "line": "" }, { "price": "", "size": "", "line": "" }] }
                    baseData.runners.push(data)
                })
                market.marketBook = baseData
            }
            if (market.provider !== "BETHUBS") {
                if (!market.marketBook || mkt.status === "CLOSED" || market.marketBook.status === "CLOSED" || market.marketBook.status === "INACTIVE" || market.marketBook.status === "INACTIVE" || !market.marketBook.runners || market.marketBook.runners.length < 2) {
                    return false
                }
            }
            if (eventIndex === -1) {
                let evt = mkt.event
                evt.isInplay = market.inPlay === true ? true : false
                evt.eventTypeId = mkt.eventType.id
                evt.eventType = mkt.eventType.name
                evt.competitionId = mkt.competition.id
                evt.compititionName = mkt.competition.name
                evt.markets = [market]
                events.push(evt)
            } else {
                events[eventIndex].isInplay = market.inPlay === true ? true : events[eventIndex].isInplay
                events[eventIndex].markets.push(market)
            }
        })
        events = events.sort((vote1, vote2) => {
            if (vote1.isInplay > vote2.isInplay) return -1;
            if (vote1.isInplay < vote2.isInplay) return 1;
            if (new Date(vote1.openDate) > new Date(vote2.openDate)) return 1;
            if (new Date(vote1.openDate) < new Date(vote2.openDate)) return -1;
            if (vote1.name > vote2.name) return 1;
            if (vote1.name < vote2.name) return -1;
            return 0;
        });

        let game = events.filter((et) => {
            return et.eventTypeId === this.props.match.params.game_id
        })

        let pinnedEvents = localStorage.getItem("pinnedEvents")
        pinnedEvents = !!pinnedEvents ? pinnedEvents.split(",") : []
        this.setState({ game: [] }, () => {
            this.setState({ pinnedEvents: pinnedEvents, loading: false, game: finalData, gameCode: this.props.match.params.game_id })
        })
    }
    toggleMultiMarket(eventId) {
        let pinnedEvents = localStorage.getItem("pinnedEvents")
        pinnedEvents = !!pinnedEvents ? pinnedEvents.split(",") : []
        let eventIndex = pinnedEvents.indexOf(eventId)
        if (eventIndex === -1) {
            pinnedEvents.push(eventId)
        } else {
            pinnedEvents.splice(eventIndex, 1)
        }
        localStorage.setItem("pinnedEvents", pinnedEvents.toString())
        this.setState({ pinnedEvents: pinnedEvents })
    }
    gameTab(game) {
        this.setState({ game: game, gameCode: game.game_code })
    }
    updateSubscribedMarkets(mkt) {
        let mktList = this.state.subscribedMarkets
        mktList.push(mkt)
        this.setState({ subscribedMarkets: mktList })
    }
    updateSocket(skt) {
        socket = skt
    }
    formatTimeString(time) {
        let hrs = new Date(time).getHours()
        hrs = hrs < 10 ? "0" + hrs : hrs
        let min = new Date(time).getMinutes()
        min = min < 10 ? "0" + min : min
        return hrs + ":" + min
    }
    render() {
        let accData = JSON.parse(localStorage.getItem("accountData"));
        return (
            <body>
                <Header notify={this.props.notify} showSweetAlert={(options) => this.props.showSweetAlert(options)} MySwal={this.props.MySwal} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} updateSubscribedMarkets={() => { this.updateSubscribedMarkets() }} updateSocket={(skt) => { this.updateSocket(skt) }} getEvtData={(ckt, soc, ten, kbd, elc, hor, hou) => { this.getEvtData(ckt, soc, ten, kbd, elc, hor, hou) }} />
                <div className={`full-wrap mar-top100 footerpd ${(!!accData && Object.keys(accData).length > 0) ? '' : 'mar-top100-login mar-bottom0'}`}>
                    <Menu history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} />
                    <div className="col-center1 markets">
                        <div className="text-center">
                            <img alt="" src={this.props.match.params.game_id === "4" ? BASE_IMAGE_PATH + "/casino/banner/Cricket-banner.jpg" : this.props.match.params.game_id === "1" ? BASE_IMAGE_PATH + "/casino/banner/Soccer-banner.jpg" : this.props.match.params.game_id === "2" ? BASE_IMAGE_PATH + "/casino/banner/Tennis-banner.jpg" : this.props.match.params.game_id === "400" ? BASE_IMAGE_PATH + "/casino/banner/Kabaddi-banner.jpg" : this.props.match.params.game_id === "500" ? BASE_IMAGE_PATH + "/casino/banner/Election-banner.jpg" : window.location.pathname === "/game/7" ? BASE_IMAGE_PATH + "/casino/banner/horseracing-banner.jpg" : BASE_IMAGE_PATH + "/casino/banner/greyhoundracing-banner.jpg"} ></img>
                        </div>
                        {Object.keys(this.state.game).length > 0 ? Object.keys(this.state.game).map((cn, i) => {
                            let cnEvents = this.state.game[cn]
                            return <>
                                <div className="sub_path center-box"><p>{cn}</p></div>
                                {Object.keys(cnEvents).map((ev, j) => {
                                    return <>
                                        <div className='horselist w-100 table-responsive'>
                                            <dt>
                                                <div href='#' className='hrtitle' >{cnEvents[ev][0].event.name}</div>
                                            </dt>
                                            <dd className='br-bottom-hr'>
                                                <ul className='hs-time'>
                                                    {cnEvents[ev].map((mkt) => {
                                                        return <li><a title={mkt.catalogue.marketName} className={(180000 > (new Date(mkt.catalogue.marketTime).getTime() - new Date().getTime())) ? "in-play" : null} onClick={() => { this.props.history.push("/event/" + mkt.eventType.id + "/" + mkt.event.id + "/" + mkt.catalogue.marketId) }} >{this.formatTimeString(mkt.catalogue.marketTime)}</a></li>
                                                    })}
                                                    {/* return <li><a title={mkt.catalogue.marketName} className={(180000 > (new Date(mkt.catalogue.marketTime).getTime() - new Date().getTime())) ? "in-play" : null} onClick={() => { window.location.href = "/event/" + mkt.eventType.id + "/" + mkt.event.id + "/" + mkt.catalogue.marketId }} >{this.formatTimeString(mkt.catalogue.marketTime)}</a></li> */}
                                                    {/* <li><a title="R7 1000m Hcap" href="#" className="in-play">12:00</a></li>
                                                    <li><a title="R4 1200m Hcap" href="#" >12:40</a></li>
                                                    <li><a title="R4 1200m Hcap" href="#" >13:10</a></li>
                                                    <li><a title="R4 1200m Hcap" href="#" >13:30</a></li>
                                                    <li><a title="R4 1200m Hcap" href="#" >15:00</a></li>
                                                    <li><a title="R4 1200m Hcap" href="#" >15:10</a></li>
                                                    <li><a title="R4 1200m Hcap" href="#" >15:30</a></li>
                                                    <li><a title="R4 1200m Hcap" href="#" >15:50</a></li> */}
                                                </ul>
                                            </dd>
                                        </div>
                                    </>
                                })}
                            </>
                        })
                            :
                            <table className="table w-100 game-list-col">
                                <tbody>
                                    <tr style={{ backgroundColor: "#FFF" }}>
                                        <td><span style={{ marginLeft: "5px", fontSize: "14px" }}>There is no active events.</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        }
                    </div>
                </div>
            </body>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(GameList);